// @flow

import * as React from 'react';
import type { Node } from 'react';
import AsideBlock from 'components/AsideBlock';

import highlihtedProjects from 'content/highlihtedProjects';
import Button from 'components/Button';

import './style.scss';

type Props = {
  language?: string,
};

export default function HighlihtedProject(props: Props): Node {
  const { language } = props;

  let projectsToRender = [];

  if (!language) {
    projectsToRender = highlihtedProjects;
  } else {
    projectsToRender = highlihtedProjects.filter(
      ({ languages: projectsLanguages }) => projectsLanguages.includes(language)
    );
  }

  return (
    <AsideBlock
      title="Highlihted Projects"
      intro="Not well known open-source projects, that deserve for some love"
      footer={
        <p>
          You can list your open-source project free of charge
          <a
            className="main-link"
            href="https://airtable.com/shrkjCLnZoti05oTY"
          >
            here
          </a>
        </p>
      }
    >
      {projectsToRender ? (
        <ul className="HighlihtedProjects__list">
          {projectsToRender.map(
            ({ name, url, description, language: languageName }) => (
              <div className="HighlihtedProjects__item">
                <span className="HighlihtedProjects__label">
                  {languageName}
                </span>
                <Button
                  href={url}
                  isText
                  isTargetBlank
                  onClick={() => {
                    if (process.env.NODE_ENV === 'production')
                      window.analytics.track('Highlihted project clicked', {
                        name,
                      });
                  }}
                >
                  {name}
                </Button>
                <p className="HighlihtedProjects__description">
                  {description || ''}
                </p>
              </div>
            )
          )}
        </ul>
      ) : (
        <div className="HighlihtedProjects__item">
          Nothing&#39;s there yet. Consider listing your project here for free
        </div>
      )}
    </AsideBlock>
  );
}

HighlihtedProject.defaultProps = {
  language: '',
};
